import React from 'react';
import Blocks from './Blocks';

import './games.css';

const HomeGames = () => {
    return (
        <div className="home_games_wrapper">
            <div className="container">
                <Blocks/>
            </div>
        </div>
    );
};

export default HomeGames;
